<template>
  <fieldset :id="id">
    <legend>{{ title }}</legend>
    <transition-group
      name="fade"
      mode="out-in"
    >
      <template v-for="lang in existingLang">
        <el-form-item
          :prop="getPropName(row, lang)"
          :key="lang.key || lang"
          :label="lang.key || lang"
        >
          <el-input
            v-bind="inputAttrs"
            :value="row.isInObject ? form[key][`${objectKey}${lang.suffix || lang}`] : form[`${key}${lang.suffix || lang}`]"
            :disabled="disabled"
            type="textarea"
            @input="v => handleInput(v, lang)"
          />
        </el-form-item>
      </template>
    </transition-group>
    <div v-if="toBeAddedLang.length > 0">
      <span class="add-more-lang">{{ $t('form.addMoreLanguages') }}:</span>
      <template v-for="lang in toBeAddedLang">
        <el-button
          :key="lang.key"
          class="my-1"
          @click="handleClickAddLanguage(lang)"
        >{{ lang.key }}</el-button>
      </template>
    </div>
  </fieldset>
</template>

<script>
import uuidv4 from 'uuid/v4'

import { getLanguageList } from '../../utils/form'

export default {
  name: 'FieldsetLocalizedInput',
  props: {
    title: {
      type: String,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: `x${uuidv4()}`,
    }
  },
  computed: {
    key() {
      return this.row.key
    },
    languageList() {
      return this.row.languages || getLanguageList(this.form, this.key, this.objectKey)
    },
    // for localized each row element only
    objectKey() {
      return this.row.objectKey == 'undefined' ? this.row.objectKey : 'value'
    },
    existingLang() {
      if (!this.row.isLocalized || !this.languageList) {
        return []
      }
      return this.languageList.filter((lang) => {
        let text = this.form[`${this.key}${lang.suffix}`]
        if (this.row.isInObject) {
          text = this.form[this.key][`${this.objectKey}${lang.suffix}`]
        }
        return text !== null
      })
    },
    toBeAddedLang() {
      const existingLangSet = new Set(this.existingLang.map(lang => lang.key))
      return this.languageList.filter(lang => !existingLangSet.has(lang.key))
    },
    inputAttrs() {
      return {
        autosize: true,
        ...this.row.custom,
      }
    },
  },
  methods: {
    handleInput(v, { suffix }) {
      if (this.row.isInObject) {
        this.form[this.key][`${this.objectKey}${suffix}`] = v
      } else {
        this.form[`${this.key}${suffix}`] = v
      }
    },
    handleClickAddLanguage({ key, suffix }) {
      if (this.row.isInObject) {
        this.form[this.key][`${this.objectKey}${suffix}`] = ''
      } else {
        this.form[`${this.key}${suffix}`] = ''
      }
      this.$nextTick(() => {
        // auto focus the textarea of the new language
        const index = this.existingLang.findIndex(lang => lang.key === key)
        document.querySelector(`fieldset#${this.id} .el-form-item:nth-of-type(${index + 1}) textarea`).focus()
      })
    },
    getPropName({ key }, { suffix }) {
      return `${key}${suffix}`
    },
  },
}
</script>

<style lang="scss" scoped>
legend {
  font-weight: 500;
}

.add-more-lang {
  font-size: 14px;
  margin-right: 6px;
}
</style>
